import { Injectable } from '@angular/core';
import { NgbModal }   from '@ng-bootstrap/ng-bootstrap';

import { ApiService }                     from '../../api/api.service';
import { CriticalMessageComponent }       from './critical-message.component';
import { CriticalMessageModel }           from './typings/critical-message';
import { TableQueryParameters }           from '../../table/types/table-query-parameters';
import { VerifyCriticalMessageComponent } from './critical-messages.verify.component';

@Injectable({
  providedIn: 'root'
})
export class CriticalMessagesService {
  constructor (
    private apiService  : ApiService,
    private modalService: NgbModal
  ) {}

  create () : Promise<void> {
    return this.modalService.open(CriticalMessageComponent, {
      size: 'lg'
    }).result;
  }

  get ( params : TableQueryParameters = {} ) : Promise<Array<CriticalMessageModel>> {
    return this.apiService.get('mobile_notifications', [
      params.pageSize || 5,
      params.offset   || 0
    ]);
  }

  getCount () : Promise<number> {
    return this.apiService.get('mobile_notifications_count')
      .then(response => response.count);
  }

  requestCode ( message : CriticalMessageModel ) : Promise<CriticalMessageModel> {
    return this.apiService.post('/mobile_notifications', message, 'mobile_notification');
  }

  validateCode ( verificationCode : string, message : CriticalMessageModel ) : Promise<boolean> {
    return this.apiService.post(`/mobile_notifications/${ message.id }/validate_code`, {
      verification_code: verificationCode
    });
  }

  verify ( message : CriticalMessageModel ) : Promise<void> {
    const modal = this.modalService.open(VerifyCriticalMessageComponent);

    modal.componentInstance.message = message;

    return modal.result;
  }
}
